export enum OrganizationChartItemType {
	None = 0,
	User = 1,
	Function = 2,
	Department = 3,
  Entity = 4,
	CurrentUser = 6,
	API = 7,
	TypeAheadPendingStep = 100
}

export enum FilterOrgChartItemType
{
  User = 1,
  Function = 2,
  Department = 3,
  Entity = 4,
  CurrentUser = 6
}